import { supabase } from '../lib/supabase';

export const fetchErrorLogs = async (filter = 'all', showResolved = false) => {
  let query = supabase.from('error_logs').select('*')
    .order('created_at', { ascending: false }).limit(100);
  if (!showResolved) query = query.eq('resolved', false);
  if (filter !== 'all') query = query.eq('error_type', filter);
  const { data, error } = await query;
  if (error) throw error;
  return data || [];
};

export const markErrorResolved = async (id) => {
  await supabase.from('error_logs').delete().eq('id', id);
};
